import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-group-mapping',
    templateUrl: './group-mapping.component.html',
    styleUrls: ['./group-mapping.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GroupMappingComponent {
    @Input() form: FormGroup;
    @Input() exportType: string;
    @Input() mappingType: string;
    @Input() mappings: Array<any>;
    @Input() fields: Array<any>;

    currentGroupId = 0;

    setCurrentGroup(groupId) {
        this.currentGroupId = groupId;
    }
}
